import React, { useEffect, useRef } from "react";
import { Navigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";

const KycGuard = ({ children }) => {
  const location = useLocation();
  const hasShownToast = useRef(false);

  const getUser = () => {
    try {
      return JSON.parse(sessionStorage.getItem("authUser"));
    } catch {
      return null;
    }
  };

  const currentUser = getUser();

  const kycVerified = currentUser?.user?.kycVerified;

  const allowedPaths = ["/new-merchant", "/logout"];
  const isAllowed = allowedPaths.includes(location.pathname);

  useEffect(() => {
    if (kycVerified === false && !isAllowed && !hasShownToast.current) {
      toast.error("Veuillez compléter votre KYC d'abord");
      hasShownToast.current = true;
    }
  }, [kycVerified, isAllowed]);

  if ((currentUser?.roles === "MERCHANT" || currentUser?.roles === "COLLABORAT0R") && (kycVerified === undefined || kycVerified === null)) {
    return (
      <div className="dashb-global-loader">
        <div className="dashb-skeleton dashb-header"></div>

        <div className="dashb-content">
          <div className="dashb-sidebar">
            <div className="dashb-skeleton dashb-menu-item"></div>
            <div className="dashb-skeleton dashb-menu-item"></div>
            <div className="dashb-skeleton dashb-menu-item"></div>
            <div className="dashb-skeleton dashb-menu-item"></div>
          </div>

          <div className="dashb-main">
            <div className="dashb-skeleton dashb-title"></div>

            <div className="dashb-cards">
              <div className="dashb-skeleton dashb-card"></div>
              <div className="dashb-skeleton dashb-card"></div>
              <div className="dashb-skeleton dashb-card"></div>
            </div>

            <div className="dashb-skeleton dashb-chart"></div>
          </div>
        </div>
      </div>
    );
  }

  if (kycVerified === false && !isAllowed) {
    return <Navigate to="/new-merchant" replace />;
  }

  return children;
};

export default KycGuard;